import React from 'react'

export const OwlIcon = () => (
  <svg
    height="24px"
    version="1.1"
    viewBox="0 0 78 76"
    width="25px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <polygon
        id="path-1"
        points="0 75.6189047 77.3431358 75.6189047 77.3431358 0.598949737 0 0.598949737"
      ></polygon>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      id="Wireframe---OWL-Airdrop"
      stroke="none"
      strokeWidth="1"
      transform="translate(-706.000000, -640.000000)"
    >
      <g id="OWL-icon" transform="translate(685.000000, 625.000000)">
        <g id="owl_icon" transform="translate(21.290323, 15.064516)">
          <g id="Group-4">
            <path
              d="M23.7715829,37.0387997 L13.3589797,26.6886122 C12.4209452,27.9489272 11.8550038,29.5135184 11.8550038,31.2011403 C11.8550038,35.2851613 15.179835,38.6069917 19.2572543,38.6069917 C20.9496774,38.6069917 22.5196699,38.0392498 23.7715829,37.0387997"
              fill="#00A2C9"
              id="Fill-1"
            ></path>
            <g id="Group-5" transform="translate(0.000000, 0.001200)">
              <mask fill="white" id="mask-2">
                <use xlinkHref="#path-1"></use>
              </mask>
              <g id="Clip-4"></g>
              <path
                d="M11.3530383,14.0856414 C18.0057014,7.62202551 26.7204801,4.10994749 36.0690173,4.10994749 L36.127832,4.10994749 C36.2304576,4.10994749 36.3336834,4.11534884 36.4363091,4.11774944 L36.4363091,39.2313278 L11.3530383,14.0856414 Z M42.3849962,36.8397299 L42.3849962,34.251883 L76.144036,34.251883 L76.144036,31.664036 L42.3849962,31.664036 L42.3849962,29.076189 L75.0901725,29.076189 L75.0901725,26.4883421 L42.3849962,26.4883421 L42.3849962,23.9004951 L67.2168042,23.9004951 L67.2168042,21.3126482 L42.3849962,21.3126482 L42.3849962,18.7254014 L71.7755439,18.7254014 L71.7755439,16.1369542 L42.3849962,16.1369542 L42.3849962,13.5497074 L69.2789197,13.5497074 L69.2789197,10.9618605 L42.3849962,10.9618605 L42.3849962,8.3740135 L62.315979,8.3740135 L62.315979,5.78616654 L42.3849962,5.78616654 L42.3849962,3.19891973 L49.691823,3.19891973 L49.691823,0.610472618 L36.0024006,0.598469617 C25.1522881,0.598469617 15.055964,4.99156789 7.65311328,12.8259265 L6.460015,14.0856414 L36.4363091,44.1927682 L36.4363091,49.5917179 L36.3180795,49.7099475 L28.6043511,41.9326032 C25.0268567,44.3163991 20.4489122,45.0077719 16.1242311,43.5007952 C8.84501125,40.8667367 5.08027007,32.8997449 7.71732933,25.6877419 C8.09242311,24.5594599 8.65596399,23.5548087 9.28192048,22.616174 L5.95948987,19.2895424 L5.33413353,20.356009 C1.88147037,26.004021 2.71050543e-20,32.5258515 2.71050543e-20,39.236129 C-0.0600150038,59.248132 16.2448612,75.6094224 36.2514629,75.6094224 L49.691823,75.6190248 L49.691823,73.0305776 L42.3849962,73.0305776 L42.3849962,70.4427307 L62.315979,70.4427307 L62.315979,67.8554839 L42.3849962,67.8554839 L42.3849962,65.2682371 L69.2789197,65.2682371 L69.2789197,62.6797899 L42.3849962,62.6797899 L42.3849962,60.0925431 L71.7755439,60.0925431 L71.7755439,57.5046962 L42.3849962,57.5046962 L42.3849962,54.9168492 L73.2183046,54.9168492 L73.2183046,52.3290023 L42.3849962,52.3290023 L42.3849962,49.7411553 L75.0901725,49.7411553 L75.0901725,47.1539085 L42.3849962,47.1539085 L42.3849962,44.5660615 L70.1425356,44.5660615 L70.1425356,41.9776144 L42.3849962,41.9776144 L42.3849962,39.3897674 L77.3431358,39.3897674 L77.3431358,38.1252513 L77.3431358,38.1042461 L77.3431358,36.8397299 L42.3849962,36.8397299 Z"
                fill="#00A2C9"
                id="Fill-3"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
